export default function isPremiumPlan(plan) {
  return (
    plan.toLowerCase().includes('annual') ||
    plan.toLowerCase().includes('monthly') ||
    plan.toLowerCase().includes('awn-pp')
  );
}
